import { useMemo } from "react";
import { IComponentType, ITrackingTypes } from "../component-data-structure";
import { getScreenRelativeComponentIds } from "../utils/general";
export const getFaceLandmarkIdsBySceneId = (sceneId, componentsById) => {
    const activeSceneChildren = componentsById[sceneId]?.children || [];
    return activeSceneChildren.filter(id => componentsById[id].type === IComponentType.FaceLandmarkGroup);
};
export const useGetScreenRelativeComponentIds = (sceneId, componentsById) => {
    return useMemo(() => {
        return getScreenRelativeComponentIds(sceneId, componentsById);
    }, [componentsById, sceneId]);
};
export const useGetFaceTrackedComponentIds = (sceneId, componentsById) => {
    return useMemo(() => {
        return getFaceTrackedComponentIds(sceneId, componentsById);
    }, [componentsById, sceneId]);
};
export const getFaceTrackedComponentIds = (sceneId, componentsById) => {
    if (!componentsById)
        return [];
    if (componentsById[sceneId].trackingType !== ITrackingTypes.face)
        return [];
    const faceLandmarkIds = getFaceLandmarkIdsBySceneId(sceneId, componentsById);
    return faceLandmarkIds.reduce((acc, landmarkId) => {
        const landmarkGroup = componentsById[landmarkId];
        return [...acc, ...landmarkGroup.children];
    }, []);
};
